module.exports = __webpack_public_path__ + "img/basic.48b0f225.svg";